import React from 'react'
import { Table } from 'antd'

import Container from './styles'

const TableContainer = ({ dataSource = [], pageSize = 9, ...props }) => {
  return (
    <Container>
      <Table
        dataSource={dataSource}
        bordered={false}
        pagination={{ pageSize }}
        {...props}
      />
    </Container>
  )
}

export default TableContainer
